import { Component, OnInit } from '@angular/core';
import { CompanyService } from 'app/services/company.service';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss'],
})
export class TermsConditionsComponent implements OnInit {
  termsAndConditions: string;
  isLoading: boolean = false;

  constructor(private companyService: CompanyService) {}

  ngOnInit() {
    this.getTermsAndConditions();
  }

  getTermsAndConditions() {
    this.isLoading = true;
    this.companyService.getTermsAndConditions().subscribe(
      (data: any) => {
        this.termsAndConditions = data?.termsAndConditions;
        this.isLoading = false;
      },
      (error) => {
        console.error('Error fetching terms and conditions', error);
        this.isLoading = false;
      }
    );
  }
}
